import __axios from "axios";
import { axiosV2 } from "config/@axios";

export const FETCH_HEADER_INFO = "headerInfoActions::fetchHeaderInfo";
export const FETCH_HEADER_INFO_SUCCESS =
  "headerInfoActions::fetchHeaderInfoSuccess";
export const FETCH_HEADER_INFO_FAILED =
  "headerInfoActions::fetchHeaderInfoFailed";

const CancelToken = __axios.CancelToken;
let cancel;

export const fetchHeaderInfo = email => (dispatch, getState) => {
  const state = getState();

  const existingEntry = Object.values(state.headerInfo?.byId || {}).find(
    entry => entry.email === email
  );

  if (existingEntry) {
    return Promise.resolve(existingEntry);
  }

  cancel && cancel();

  dispatch({
    type: FETCH_HEADER_INFO,
    payload: { email }
  });

  return axiosV2
    .get(`/contacts/address/${email}`, {
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      })
    })
    .then(response => {
      const data = response.data;
      dispatch({
        type: FETCH_HEADER_INFO_SUCCESS,
        payload: {
          email,
          data
        }
      });
      return data;
    })
    .catch(err => {
      if (__axios.isCancel(err)) {
        return;
      }

      dispatch({
        type: FETCH_HEADER_INFO_FAILED,
        payload: {
          email,
          errorText: err.message
        }
      });
    })
    .finally(() => {
      cancel = null;
    });
};
